import React from 'react';
import PropTypes from 'prop-types';
import { makeStyles } from '@material-ui/core/styles';
import Typography from '@material-ui/core/Typography';
import CheckCircleOutlineIcon from '@material-ui/icons/CheckCircleOutline';
import Button from '../../../components/Button.js';

const useStyles = makeStyles(theme => ({
  content: {
    display: 'flex',
    flexWrap: 'wrap',
    width: '100%',
    justifyContent: 'center',
  },
  unselected: {
    position: 'relative',
    margin: '1rem 1.5rem',
    borderRadius: '5px',
    backgroundColor: theme.palette.common.white,
  },
  selected: {
    position: 'relative',
    margin: '1rem 1.5rem',
    borderRadius: '5px',
    backgroundColor: theme.palette.grey['200'],
  },
  option: {
    cursor: 'pointer',
    display: 'flex',
    flexWrap: 'wrap',
    justifyContent: 'center',
    alignItems: 'center',
    height: '8rem',
    width: '12rem',
    borderRadius: '5px',
    border: `1px solid ${theme.palette.primary.main}`,
    padding: '1rem',
    '&:hover': {
      border: `1px solid ${theme.palette.primary.main}`,
      backgroundColor: theme.palette.common.highlightBlue,
      boxShadow: `0px 0px 5px 0px ${theme.palette.primary.main}`,
    },
  },
  text: {
    width: '100%',
    textAlign: 'center',
    fontWeight: 500,
    clear: 'both',
    left: '-5px',
    position: 'relative',
  },
  icon: {
    position: 'absolute',
    top: 5,
    left: 5,
    fontSize: '2.5rem',
    color: theme.palette.common.tealish,
  },
  button: {
    padding: '1rem 0',
    display: 'flex',
    justifyContent: 'center',
  },
}));

const MultiSelectBoxesOptions = ({item, options, handleAnswer, selectedValues}) => {
  const classes = useStyles();
  const [selections, setSelections] = React.useState(selectedValues);

  const handleClick = (option) => {
    let newSelections = selections.map(item => item);
    if (selections.includes(option)) {
      newSelections = newSelections.filter(e => e !== option);
    } else {
      newSelections.push(option);
    }
    setSelections(newSelections);
  };

  const handleSubmit = () => {
    handleAnswer(item, selections);
  };

  return (
    <React.Fragment>
      <div className={classes.content}>
        {options.map(opt => {
          const selected = selections.includes(opt.label);
          return (
            <div
              key={opt.id}
              className={selected ? classes.selected : classes.unselected}
              onClick={()=>handleClick(opt.label)}
              selections={selections}
            >
              <div className={classes.option}>
                {selected ? (<CheckCircleOutlineIcon className={classes.icon}/>) : null}
                <Typography
                  variant="h3"
                  className={classes.text}
                >
                  {opt.label}
                </Typography>
              </div>
            </div>
          );
        })}
      </div>
      <div className={classes.button}>
        <Button
          onClick={handleSubmit}
          label="Next"
          pointer="right"
          variant="contained"
        />
      </div>
    </React.Fragment>
  );
};

MultiSelectBoxesOptions.propTypes = {
  item: PropTypes.string.isRequired,
  options: PropTypes.array.isRequired,
  handleAnswer: PropTypes.func.isRequired,
  selectedValues: PropTypes.array.isRequired,
};

export default MultiSelectBoxesOptions;
